<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：购电记录
    -->
	<div class="orderList">
		<span class="orderList_all_total">金额合计：{{allTotal/100}} 元</span>
		<!--搜索-->
		<el-form :inline="true" :model="formInline" class="demo-form-inline" @keyup.enter.native="search">
			<el-form-item label="户号">
				<el-input v-model="formInline.account" placeholder="户号" style="width:150px" :maxlength="12"></el-input>
			</el-form-item>
			<el-form-item label="表号">
				<el-input v-model="formInline.code" placeholder="表号" style="width:150px" :maxlength="12"></el-input>
			</el-form-item>
			<el-form-item label="表类型">
				<el-select v-model="formInline.typess" placeholder="请选择" style="width: 90px;">
					<el-option v-for="item in typess" :key="item.id" :label="item.label" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="业主类型">
				<el-select v-model="formInline.nature" placeholder="请选择" style="width: 110px;">
					<el-option v-for="item in natures" :key="item.num" :label="item.value" :value="item.num">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="业主姓名">
				<el-input v-model="formInline.owner_name" placeholder="业主姓名" style="width:100px"></el-input>
			</el-form-item>

			<el-form-item label="地址">
				<el-input v-model="formInline.address" placeholder="地址" style="width:150px;"></el-input>
			</el-form-item>
			<el-form-item label="充值时间">
				<el-date-picker v-model="formInline.value2" type="date" placeholder="选择开始日期">
				</el-date-picker>
				<el-date-picker v-model="formInline.value3" type="date" placeholder="选择结束日期">
				</el-date-picker>
			</el-form-item>
			<!--<el-form-item label="支付状态">
				<el-select v-model="formInline.status" placeholder="请选择" style="width: 110px;">
					<el-option v-for="statu in status" :key="statu.id" :label="statu.text" :value="statu.id">
					</el-option>
				</el-select>
			</el-form-item>-->
			<el-form-item label="支付方式">
				<el-select v-model="formInline.type" placeholder="请选择" style="width: 110px;">
					<el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item>
				<el-button type="primary" @click="search">查询</el-button>
				<el-button type="primary" @click="resetting">重置</el-button>
				<el-button type="primary" @click="downorderCode()">导出</el-button>
			</el-form-item>
		</el-form>
		<!--搜索结果列表-->
		<el-table :data="orderList" border style="width:1777px;text-align:center;margin-bottom: 10px;font-size:12px;" v-on:sort-change="sortChange">
			<el-table-column prop="order_code" label="订单编号" align="center" width="190" sortable="custom">
			</el-table-column>
			<el-table-column prop="account" label="户号" width="125" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="meter_code" label="表号" width="125" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="tra_type" label="表类型" width="100" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="total" :formatter="formatter" label="充值金额(元)" width="130" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="amount" label="充值水量（吨）" width="145" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="nature" label="业主类型" width="110" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="owner_name" label="业主姓名" width="130" align="center" sortable="custom">
			</el-table-column>
			<!--<el-table-column prop="owner_phone" label="业主手机号" width="123" align="center" sortable="custom">
			</el-table-column>-->
			<el-table-column prop="address" label="地址"  width="370" align="center" sortable="custom">
			</el-table-column>
			<!--<el-table-column prop="buildnum" label="栋" width="120" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="unitnum" label="单元" width="120" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="doornum" label="门牌号" width="120" align="center" sortable="custom">
			</el-table-column>-->
			<el-table-column prop="pay_type" label="支付方式" width="120" align="center" sortable="custom">
				<template scope="scope">
					<el-tag v-if="1 == scope.row.pay_type" type="primary">支付宝</el-tag>
					<el-tag v-if="2 == scope.row.pay_type" type="primary">微信</el-tag>
					<el-tag v-if="3 == scope.row.pay_type" type="primary">银联</el-tag>
					<el-tag v-if="4 == scope.row.pay_type" type="primary">现金</el-tag>
					<el-tag v-if="5 == scope.row.pay_type" type="primary">支票</el-tag>
					<el-tag v-if="6 == scope.row.pay_type" type="primary">光大银行</el-tag>
					<el-tag v-if="7 == scope.row.pay_type" type="primary">直充</el-tag>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="community_name" label="小区名称" width="180">
			</el-table-column>-->
			<el-table-column prop="create_time" label="创建日期" width="230" align="center" sortable="custom">
			</el-table-column>
			<!--<el-table-column prop="status" label="处理状态" width="132" align="center" sortable="custom">
				<template scope="scope">
					<el-tag v-if="3 === scope.row.status" style="background-color:#56e63a;color:white;">充值成功</el-tag>
					<el-tag v-if="2 === scope.row.status" style="background-color:#098aee;color:white;">处理中</el-tag>
					<el-tag v-if="-3 === scope.row.status" style="background-color:#ff0000;color: white;">充值失败</el-tag>
				</template>
			</el-table-column>-->
			<!--<el-table-column prop="sumbit" width="100" align="center" label="操作">
				<template scope="scope">		
						<el-button type="primary" @click="print(scope.row.order_id)" size="mini">打印</el-button>
				</template>
			</el-table-column>-->
			<el-table-column prop="sumbit" width="100" align="center" label="操作">
				<template scope="scope">		
					<el-button type="primary" @click="onToSmallChange(scope.row.order_id, scope.row.cycle)" size="mini">详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total,prev, pager, next" :total="total">
		</el-pagination>

		<!-- details -->
		<div class="details" v-if="detailsShow">
			<div class="details_back"></div>
			<div class="details_main">

				<div class="details_main_item">
					<label>户号：</label>
					<span class="content">{{details.account}}</span>
				</div>

				<div class="details_main_item">
					<label>表号：</label>
					<span class="content">{{details.meter_code}}</span>
				</div>

				<div class="details_main_item">
					<label>业主名称：</label>
					<span class="content">{{details.owner_name}}</span>
				</div>

				<div class="details_main_item">
					<label>地址：</label>
					<span class="content">{{details.address}}</span>
				</div>

				<div class="details_main_item">
					<label>支付方式：</label>
					<span class="content">{{details.pay_type == 1 ? '支付宝' : details.pay_type == 2 ? '微信支付' : details.pay_type == 3 ? '银联' : details.pay_type == 4 ? '现金' : details.pay_type == 5 ? '支票' : details.pay_type == 6 ? '光大银行' : '直充'}}</span>
				</div>

				<div class="details_main_item">
					<label>支付前余额：</label>
					<span class="content">￥{{details.before_blance}}</span>
				</div>

				<div class="details_main_item" v-if="isYear">
					<label>支付前本年用量：</label>
					<span class="content">{{details.yeartotal}}度</span>
				</div>

				<div class="details_main_item" v-if="isYear">
					<label>入表金额：</label>
					<span class="content content_red">￥{{details.meter_money}}</span>
				</div>

				<div class="details_main_item">
					<label>支付金额：</label>
					<span class="content">￥{{chu(details.total)}}</span>
				</div>

				<div class="details_main_item" v-if="isYear">
					<label>补交阶梯差价：</label>
					<span class="content">￥{{details.diff_money}}</span>
					<a :href="'/explain/explain-detailed?yeartotal=' + details.yeartotal + '&newyear=' + 1" target="_blank">说明</a>
				</div>

				<div class="details_main_item">
					<label>透支金额：</label>
					<span class="content">￥{{details.over_money}}</span>
				</div>

				<div class="details_main_item" v-if="isYear">
					<label>存入零钱：</label>
					<span class="content">￥{{details.pocket_in}}</span>
				</div>

				<div class="details_main_item" v-if="isYear">
					<label>本次充值后零钱余额：</label>
					<span class="content">￥{{details.pocket_after}}</span>
				</div>

				<div class="details_main_item" v-if="isYear">
					<label>本次充值后零钱支付：</label>
					<span class="content">￥{{details.pocket_out}}</span>
				</div>

				<div class="details_main_item">
					<label>支付后电表余额：</label>
					<span class="content">{{details.after_blance}}</span>
				</div>

				<div class="details_main_item">
					<label>支付时间：</label>
					<span class="content">{{details.create_time}}</span>
				</div>

				<div class="details_main_item">
					<label>充值状态：</label>
					<span class="content">{{details.status}}</span>
				</div>

				<div class="details_main_buttonGroup">
					<el-button type="primary" round @click="detailsShow = false">关闭</el-button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import { mapMutations,mapState } from 'vuex'
	export default {
		name: 'order-list',
		data() {
			return {
				formInline: {
					account: '',
					code: '',
					owner_name: '',
					value2: '',
					value3: '',
					status: '',
					type: '',
					nature: '',
					address:'',
					typess:'',
				},
				allTotal:'',
				prop:'',
				order:'',
				natures: [/*{
						num: '0',
						value: '居民',
					},
					{
						num: '1',
						value: '自营'
					},
					{
						num: "2",
						value: '联营'
					},
					{
						num: '3',
						value: '出租'
					},
					{
						num:'4',
						value:'物业动力'
					},
					{
						num:'5',
						value:'居民配套'
					},
					{
						num: '9',
						value: '备用'
					},*/

				],
				status: [{
						id: '2',
						text: '处理中'
					},
					{
						id: '3',
						text: '充值成功'
					},
					{
						id: '-3',
						text: '充值失败'
					}
				],
				typess: [
					{
						id: '7',
						label: '水表'
					},
					{
						id: '10',
						label: '多功能单相'
					},
					{
						id: '11',
						label: '多功能三相'
					}
				],
				types: [],
				orderList: [],
				total: 0,
				pageSize: 15,

				detailsShow: false,
				isYear: true,
				details: {
					account: '',
					meter_code: null,
					owner_name: '',
					address: '',
					pay_type: null,
					before_blance:'',
					yeartotal: '',
					meter_money: '',
					total: '',
					diff_money: '',
					over_money: '',
					pocket_in: '',
					pocket_after: '',
					pocket_out: '',
					after_blance: '',
					create_time: '',
					status: '',
					diff: null,
				},
			}
		},
		created:function(){
			this.searchNature()
			this.search()
			return ;
		},
		methods: {
			searchNature(){
				this.$jssdk.authority.pay({
					
				},(res) =>{
					this.types = res
					console.log(res)
				})
				this.$jssdk.member.getNature({
					
				},(res) =>{
					this.natures = res
					console.log(res)
				})
			},
			sortChange(item) {
				var order = item.order
				var prop = item.prop
				this.prop = prop
				this.order = order
				const account = this.formInline.account
				const code = this.formInline.code
				const ownerName = this.formInline.owner_name
				const value2 = this.formInline.value2
				const value3 = this.formInline.value3
				const status = this.formInline.status
				const type = this.formInline.type
				let nature = this.formInline.nature
				var address = this.formInline.address
				let typess = this.formInline.typess
				this.$jssdk.order.list({
					account: account,
					code: code,
					owner_name: ownerName,
					start_time: value2,
					end_time: value3,
					status: status,
					pay_type: type,
					is_export: '0',
					nature: nature,
					sort_by: prop,
					sort_to: order,
					address:address,
					type: typess
				}, (data) => {
					
					this.orderList = data.orderList.data
					this.total = data.orderList.total
					for(var i = 0; i < data.orderList.data.length; i++) {
						if(data.orderList.data[i].nature == '0') {
							this.orderList[i].nature = '居民'
						}
						if(data.orderList.data[i].nature == '1') {
							this.orderList[i].nature = '自营'
						}
						if(data.orderList.data[i].nature == '2') {
							this.orderList[i].nature = '联营'
						}
						if(data.orderList.data[i].nature == '3') {
							this.orderList[i].nature = '出租'
						}
						if(data.orderList.data[i].nature == '4'){
							this.orderList[i].nature = '物业动力'
						}
						if(data.orderList.data[i].nature == '5'){
							this.orderList[i].nature = '居民配套'
						}
						if(data.orderList.data[i].nature == '9') {
							this.orderList[i].nature = '备用'
						}
					}
				}, (err) => {
					this.$message({
						type: 'warning',
						message: err.msg,
						duration: 1000
					})
				});
			},
			search() {
				const account = this.formInline.account
				const code = this.formInline.code
				const ownerName = this.formInline.owner_name
				const value2 = this.formInline.value2
				const value3 = this.formInline.value3
				const status = this.formInline.status
				const type = this.formInline.type
				let nature = this.formInline.nature
				var address = this.formInline.address
				let typess = this.formInline.typess
				this.$jssdk.order.list({
					account: account,
					code: code,
					owner_name: ownerName,
					start_time: value2,
					end_time: value3,
					status: status,
					pay_type: type,
					type: typess,
					is_export: '0',
					nature: nature,
					address:address
				}, (data) => {
					this.orderList = data.orderList.data
					this.allTotal = data.orderList.all_total
					this.total = data.orderList.total
					for(var i = 0; i < data.orderList.data.length; i++) {
						if(data.orderList.data[i].nature == '0') {
							this.orderList[i].nature = '居民'
						}
						if(data.orderList.data[i].nature == '1') {
							this.orderList[i].nature = '自营'
						}
						if(data.orderList.data[i].nature == '2') {
							this.orderList[i].nature = '联营'
						}
						if(data.orderList.data[i].nature == '3') {
							this.orderList[i].nature = '出租'
						}
						if(data.orderList.data[i].nature == '4'){
							this.orderList[i].nature = '物业动力'
						}
						if(data.orderList.data[i].nature == '5'){
							this.orderList[i].nature = '居民配套'
						}
						if(data.orderList.data[i].nature == '9') {
							this.orderList[i].nature = '备用'
						}
					}
				}, (err) => {
					this.$message({
						type: 'warning',
						message: err.msg,
						duration: 1000
					})
				});
			},
			downorderCode() {
				const account = this.formInline.account
				const code = this.formInline.code
				const ownerName = this.formInline.owner_name
				const value2 = this.formInline.value2
				const value3 = this.formInline.value3
				const status = this.formInline.status
				const type = this.formInline.type
				let nature = this.formInline.nature
				var address = this.formInline.address
				let typess = this.formInline.typess
				this.$jssdk.order.list({
					account: account,
					code: code,
					owner_name: ownerName,
					start_time: value2,
					end_time: value3,
					status: status,
					pay_type: type,
					is_export: '1',
					nature: nature,
					address:address,
					sort_by: this.prop,
					sort_to: this.order,
					type: typess
				}, (data) => {
					window.location.href = data.url
				}, (err) => {
					this.$message({
						type: 'warning',
						message: err.msg,
						duration: 1000
					})
				});
			},
			resetting() {
				this.formInline.account = ''
				this.formInline.code = ''
				this.formInline.owner_name = ''
				this.formInline.value2 = ''
				this.formInline.value3 = ''
				this.formInline.status = ''
				this.formInline.type = ''
				this.formInline.nature = ''
				this.formInline.address = ''
				this.formInline.typess = ''
			},
			formatter(row, column) {
				let num = row[column.property] / 100;
				let xs = String(num).split(".")[1];
				let over;
				if(typeof(xs) == 'undefined'){
					over = num + '.00';
				} else if(xs.length == 1){
					over = num + '0';
				} else {
					over = num;
				}
				// return row[column.property] / 100+'.00'
				return over;
			},
			/* print (orderId) {
			 	this.$jssdk.order.orderInfo({orderid:orderId},(data) => {
			 		console.log(data)
			 		this.setPrintData(data)
			 		this.$nextTick(() => {
			    		window.print()
			   	})
			 	},(err) =>{
			 		return this.$message({
			 			type:'warning',
			 			message:err.msg,
			 			duration:1000
			 		})
			 	})
			 },*/
			handleSizeChange(val) {},
			handleCurrentChange(val) {
				const account = this.formInline.account
				const code = this.formInline.code
				const ownerName = this.formInline.owner_name
				const value2 = this.formInline.value2
				const value3 = this.formInline.value3
				const status = this.formInline.status
				const type = this.formInline.type
				let nature = this.formInline.nature
				var address = this.formInline.address
				let typess = this.formInline.typess
				this.$jssdk.order.list({
					account: account,
					code: code,
					owner_name: ownerName,
					start_time: value2,
					end_time: value3,
					status: status,
					pay_type: type,
					page: val,
					nature: nature,
					sort_by: this.prop,
					sort_to: this.order,
					address:address,
					type: typess
				}, (data) => {
					this.orderList = data.orderList.data
					this.total = data.orderList.total
					for(var i = 0; i < data.orderList.data.length; i++) {
						if(data.orderList.data[i].nature == '0') {
							this.orderList[i].nature = '居民'
						}
						if(data.orderList.data[i].nature == '1') {
							this.orderList[i].nature = '自营'
						}
						if(data.orderList.data[i].nature == '2') {
							this.orderList[i].nature = '联营'
						}
						if(data.orderList.data[i].nature == '3') {
							this.orderList[i].nature = '出租'
						}
						if(data.orderList.data[i].nature == '4'){
							this.orderList[i].nature = '物业动力'
						}
						if(data.orderList.data[i].nature == '5'){
							this.orderList[i].nature = '居民配套'
						}
						if(data.orderList.data[i].nature == '9') {
							this.orderList[i].nature = '备用'
						}
					}
				}, (err) => {
					this.$message({
						type: 'warning',
						message: err.msg,
						duration: 1000
					})
				});
			},
			...mapMutations(['setPrintData']),

			onToSmallChange(order_id, cycle){
				this.details = {};
				this.$jssdk.order.orderInfo({
					orderid: order_id
				}, (data) => {
					this.details = data;
					this.detailsShow = true;
					this.isYear = cycle == 2 ? true : false;
					localStorage['ladder'] = JSON.stringify(data.diff);
				}, (err) => {
					this.$message({type: 'warning',message: err.msg,duration: 1000})
				})
			},

			chu(val){
				val = val / 100;
				val = val.toFixed(2);
				return val;
			}
		},
		computed:{
			naturesData(){
				return this.natures = this.nature
			},
			...mapState(['nature'])
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.orderList {
		background-color: white;
	}
	.orderList_all_total{
		margin: 10px 0;
		display: block;
		font-family: "微软雅黑";
		font-size: 15px;
		color:red;
		font-weight: 600;
	}
	.add_meter_code {
		margin-bottom: 20px;
	}

	.details, .details_back{
		position: absolute;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
	}
	.details_back{
		z-index: 6;
		background-color: rgba(0,0,0,0.7);
	}

	.details_main{
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 6;
		transform: translateX(-50%) translateY(-50%);
		padding: 20px 50px;
		width: 550px;
		border: 2px solid #8fceff;
		border-radius: 10px;
		box-shadow: 5px 10px 10px rgba(51, 51, 51, 0.3);
		box-sizing: border-box;
		background-color: #fff;
	}

	.details_main_item:after {
		content: "";
		height: 0;
		line-height: 0;
		display: block;
		clear: both;
		visibility: hidden;
	}

	.details_main_item{
		zoom: 1;
	}

	.details_main_item label, .details_main_item span, .details_main_item a{
		float: left;
		display: block;
		height: 35px;
		line-height: 35px;
		font-size: 14px;
	}

	.details_main_item label{
		width: 140px;
		text-align: right;
	}

	.details_main_item span.content{
		font-weight: 100;
	}

	.details_main_item a{
		position: relative;
		margin-left: 30px;
		line-height: 33px !important;
		color: #20a0ff;
		text-decoration: none;
	}

	.details_main_item a::after{
		content: "";
		position: absolute;
		top: 50%;
		left: -15px;
		margin-top: -6px;
		width: 1px;
		height: 12px;
		background-color: rgb(231, 231, 231);
	}

	.details_main_buttonGroup{
		padding-top: 30px;
		text-align: center;
	}

	.details_main_buttonGroup button{
		width: 150px;
		border-radius: 20px;
	}

	.content_red{
		color: red;
		font-weight: 400 !important;
	}
</style>


// WEBPACK FOOTER //
// OrderList.vue?171fb430